export default __webpack_public_path__ + "static/media/LO04.e5cdcfb5.mp3";